export default "<site-header></site-header>\n<router-outlet></router-outlet>\n<site-footer></site-footer>"